import { Popup } from "devextreme-react/popup";

interface IAgreement {
    agreement: boolean,
    setAgreement: any
}

const Aggrement = ({ agreement, setAgreement }: IAgreement) => {


    return (
        <>
            <Popup
                visible={!agreement}
                //onHiding={() => { clearFieldsAddBuilding(); setBuilidingPopupVisible(false); setEditBuildingFlag(false); }}
                dragEnabled={true}
                deferRendering={true}
                closeOnOutsideClick={false}
                showCloseButton={false}
                showTitle={true}
                title={"Zgoda"}
                container=".dx-viewport"
                width="60%"
                height="90%"
            >

                <div className="registerRegulation">
                    <>
                        <div style={{ width: '100%', alignItems: 'center', fontWeight: 'bold' }}>INFORMACJE DOTYCZĄCE PRZETWARZANIA TWOICH DANYCH OSOBOWYCH</div>
                        Niniejszą informację otrzymałeś w związku z obowiązkami określonymi w art. 13 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dziennik Urzędowy Unii Europejskiej z dnia 4 maja 2016 r. L 119/1).
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}>Administrator danych</div>
                        Administratorem Twoich danych osobowych jest Prezydent Wrocławia. Możesz się z nami skontaktować w następujący sposób:
                        -	listownie na adres: Prezydent Wrocławia, Urząd Miejski Wrocławia, pl. Nowy Targ 1-8, 50-141 Wrocław,
                        - przez e-mail: wpo@um.wroc.pl,
                        - telefonicznie: 71 777 81 39.
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}>Cele przetwarzania danych</div>
                        Będziemy przetwarzać Twoje dane osobowe w celu przygotowania przez kreator wypełnionego formularza deklaracji
                        o wysokości opłaty za gospodarowanie odpadami komunalnymi na stronie www.deklaracje-odpady.um.wroc.pl, jeżeli wyrazisz na to wyraźną zgodę.
                        Po złożeniu deklaracji będziemy przetwarzać Twoje dane osobowe w celu realizacji zadań związanych z ustalaniem
                        i określaniem wysokości opłaty za gospodarowanie odpadami komunalnymi, jej poborem i windykacją oraz w celach kontaktowych. Numer telefonu oraz adres e-mail będziemy przetwarzać w celu wysyłania powiadomień, jeżeli wyrazisz na to wyraźną zgodę w deklaracji

                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}> Podstawy prawne przetwarzania</div>
                        Będziemy przetwarzać Twoje dane osobowe niezbędne do przygotowania deklaracji na podstawie Twojej wyraźnej zgody, którą możesz wycofać w dowolnym momencie.
                        Jeżeli złożysz deklarację będziemy przetwarzać Twoje dane osobowe na podstawie:
                        - ustawy z dnia 13 września 1996 r. o utrzymaniu czystości i porządku w gminach,
                        - ustawy z dnia 29 sierpnia 1997 r. Ordynacja podatkowa,
                        - ustawy z dnia 17 czerwca 1966 r. o postępowaniu egzekucyjnym w administracji,
                        - ustawy z dnia 27 sierpnia 2009 r. o finansach publicznych,
                        - ustawy z dnia 14 czerwca 1960r. Kodeks postępowania administracyjnego,
                        - ustawy z dnia 23 kwietnia 1964 r. Kodeks cywilny,
                        - ustawy z dnia 17 listopada 1964 r. Kodeks postępowania cywilnego.

                        Imię i nazwisko, pesel, nip, adres e-mail, adres zamieszkania/adres siedziby, dane adresowe nieruchomości będziemy przetwarzać w określonych celach na podstawie Twojej wyraźnej zgody, którą możesz wycofać w dowolnym momencie.

                        Numer telefonu oraz adres e-mail będziemy przetwarzać w określonych celach na podstawie Twojej wyraźnej zgody, którą możesz wycofać w dowolnym momencie.
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}>Okres przechowywania danych	</div>
                        Będziemy przechowywać Twoje dane w czasie niezbędnym do przygotowania deklaracji. Jeżeli złożysz deklarację Twoje dane będziemy przechowywać do czasu załatwienia Twojej sprawy a następnie przez 10 lat, licząc od stycznia kolejnego roku po jej zakończeniu
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}> Odbiorcy danych</div>
                        Będziemy przekazywać Twoje dane osobowe:
                        - naszym  dostawcom,  którym  zlecimy usługi związane
                        z przetwarzaniem danych osobowych, np. dostawcom usług IT. Takie podmioty przetwarzają dane na podstawie umowy z nami i tylko zgodnie z naszymi poleceniami,
                        - upoważnionym podmiotom przetwarzającym dane osobowe na podstawie przepisów prawa

                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}>Prawa związane z przetwarzaniem danych osobowych</div>
                        Przysługują Ci następujące prawa związane z przetwarzaniem danych osobowych:
                        -	prawo do wycofania zgody. Wycofanie zgody nie ma wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie Twojej zgody przed jej wycofaniem
                        -	prawo dostępu do Twoich danych osobowych,
                        -	prawo żądania sprostowania Twoich danych osobowych,
                        -	prawo żądania ograniczenia przetwarzania Twoich danych osobowych,
                        -	prawo żądania usunięcia Twoich danych osobowych,
                        -	prawo do przenoszenia Twoich danych osobowych, tj. prawo otrzymania od nas Twoich danych osobowych,
                        w ustrukturyzowanym, powszechnie używanym formacie informatycznym nadającym się do odczytu maszynowego. Możesz przesłać te dane innemu administratorowi danych lub zażądać, abyśmy przesłali Twoje dane do innego administratora. Jednakże zrobimy to tylko jeśli takie przesłanie jest technicznie możliwe.

                        Aby skorzystać z powyższych praw, skontaktuj się z Administratorem danych (dane kontaktowe powyżej, w pierwszym wierszu tabeli) lub Inspektorem Ochrony Danych (dane kontaktowe w kolejnym wierszu tabeli).

                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}> Inspektor Ochrony Danych </div>
                        W Urzędzie wyznaczony został Inspektor Ochrony Danych –  Sebastian Sobecki. Jest to osoba, z którą można się kontaktować w sprawach dotyczących przetwarzania Twoich danych osobowych oraz korzystania z przysługujących Ci praw związanych z przetwarzaniem danych.
                        Z Inspektorem można kontaktować się w następujący sposób:
                        - 	listownie na adres: ul. G. Zapolskiej 4, 50-032 Wrocław
                        - 	przez e-mail: iod@um.wroc.pl
                        -   telefonicznie: 71 777 77 24
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}> Prawo wniesienia skargi do organu</div>
                        Przysługuje Ci także prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych, tj. Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa.
                        <br /><br />
                        <div style={{ alignItems: 'center', fontWeight: 'bold' }}>Wyrażam zgodę, aby moje dane osobowe w zakresie obejmującym:</div>
                        <br /><br />
                        imię i nazwisko, pesel, nip, adres e-mail, adres zamieszkania/adres siedziby, dane adresowe nieruchomości były przetwarzane przez Prezydenta Wrocławia w celu przygotowania przez kreator wypełnionego formularza deklaracji
                        o wysokości opłaty za gospodarowanie odpadami komunalnymi na stronie www.deklaracje-odpady.um.wroc.pl
                        <br /><br />
                        Zgoda może być w każdym momencie wycofana poprzez kontakt z Administratorem danych: listownie na adres Prezydent Wrocławia, Urząd Miejski Wrocławia, pl. Nowy Targ 1-8, 50-141 Wrocław, przez e-mail: wpo@um.wroc.pl, telefonicznie: 71 777 81 39 lub Inspektorem Ochrony Danych  listownie na adres: ul. G. Zapolskiej 4, 50-032 Wrocław przez e-mail: iod@um.wroc.pl, telefonicznie: 71 777 77 24.
                        <br /><br />

                    </>
                </div>
                <div className="container p-3">
                    <div className="row">
                        <div className="d-flex justify-content-around">
                            <button

                                className="btnNext"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setAgreement(null)
                                }}
                            >
                                Nie wyrażam Zgody
                            </button>
                            <button
                                className="btnNext"
                                //style={{ backgroundColor: "#3cb371", &:hover: { textDecoration: 'underline', },      }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setAgreement(true)
                                }}>
                                Wyrażam Zgodę
                            </button>
                        </div>
                    </div>
                </div>

            </Popup>
        </>
    )
}

export default Aggrement